import React from "react";
import "./submitLoading.css";

const SubmitLoading = () => {
  return (
    <>
      <div className="submitLoader">
        <div className="loader">
          <div className="spin"></div>
          <div className="bounce"></div>
        </div>
      </div>
   
     </>
  );
};

export default SubmitLoading;
